import { render, staticRenderFns } from "./DigitalWallet.vue?vue&type=template&id=1cf3eeaa&scoped=true"
import script from "./DigitalWallet.vue?vue&type=script&lang=js"
export * from "./DigitalWallet.vue?vue&type=script&lang=js"
import style0 from "./DigitalWallet.vue?vue&type=style&index=0&id=1cf3eeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3eeaa",
  null
  
)

export default component.exports